// Temporary fixes to menus until plugin can be adapted
(function () {
  const labels = document.querySelectorAll(".menu__alergens-filter label");

  labels.forEach(function (label) {
    const span = document.createElement("span");
    label.appendChild(span);
  });

  const links = document.querySelectorAll(".menu__allergens-pdf-container a");

  links.forEach((link) => {
    link.textContent = "Allergens PDF";
  });
})();
